const STORAGE_KEY = "hosted_ui_token";

export function cacheHostedUiToken(token, expiresInSeconds) {
  const ttl = Number(expiresInSeconds);
  const lifetimeSeconds = Number.isFinite(ttl) && ttl > 0 ? ttl : 3600;
  const entry = { token, expiresAt: Date.now() + lifetimeSeconds * 1000 };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
}

export function getHostedUiToken() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  let entry = null;
  try {
    entry = JSON.parse(raw);
  } catch {
  }
  if (!entry || !entry.token || Date.now() >= entry.expiresAt) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
  return entry.token;
}

export function clearHostedUiToken() {
  localStorage.removeItem(STORAGE_KEY);
}
